



import {Component, Vue} from 'vue-property-decorator';
@Component({ name: 'Membership' })
export default class Membership extends Vue {}
